<template>
  <div class="disconnector">
    <div>
      <b-checkbox
        class="disconnector__title mt-0"
        :checked="isAllFieldsSelected('generalData', true)"
        @change="toggleAll($event, 'generalData', true)"
      >
        {{ $t('asset-information.menu.general-data') }}
      </b-checkbox>
    </div>
    <b-checkbox-group
      class="disconnector__checkbox-group"
      v-model="selectedFieldsProxy"
      :options="generalData.firstGeneralSection"
    />
    <fieldset class="disconnector__fieldset">
      <legend class="disconnector__legend">
        {{ $t('fields.asset.asset-info.general-data.disconnector.supportable-nominal-tension') }}
      </legend>
      <b-checkbox-group
        class="disconnector__checkbox-group"
        v-model="selectedFieldsProxy"
        :options="generalData.supportableNominalTension"
      />
    </fieldset>
    <b-checkbox-group
      class="disconnector__checkbox-group"
      v-model="selectedFieldsProxy"
      :options="generalData.secondGeneralSection"
    />
  </div>
</template>

<script>
import additionalFieldsTabMixin from '@/domain/data/generalPanel/reports/additionalFields/additionalFieldsTabMixin';
import disconnectorTabFields from '@/domain/data/generalPanel/reports/additionalFields/disconnectorTabFields';

export default {
  name: 'DisconnectorTab',
  mixins: [additionalFieldsTabMixin],
  props: {
    selectedFields: {
      type: Array,
      default: () => ([]),
    },
  },
  data: vm => ({
    fields: disconnectorTabFields(vm),
  }),
  computed: {
    generalData() {
      return this.fields.generalData || {};
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.disconnector
  max-height: 57vh
  overflow-y: auto
  &__fieldset
    margin: 10px
    padding: 5px 0
    border: 1px solid $color-border-gray
    border-radius: 3px
    .disconnector__checkbox-group ::v-deep
      .custom-control.custom-control-inline.custom-checkbox
        width: 225px
  &__legend
    font-size: 1rem
    font-weight: bold
    margin-left: 10px
    padding: 0 5px
    margin-bottom: 0
    width: auto
  &__title
    background-color: var(--color-background-dark)
    color: var(--font-color-primary)
    padding-left: 30px
    max-height: unset
    height: 30px
    display: flex
    align-items: center
    margin: 10px 0
  &__checkbox-group
    margin-left: 9px
    ::v-deep
      .custom-control-label
        font-weight: normal
      div:last-child
        width: unset !important
      > div
        min-height: 50px
        max-height: unset
        align-items: center
        width: 230px

</style>
